module.exports = __webpack_public_path__ + "img/hr-green-asterisk-03.5fca6e54.png";